import { colors } from '../../colors';
var gallery = {
  bgColor: colors.nvaBrightBlue
};
export default gallery;